<template>
  <div class="video-config">
    <div class="content-left page-background-color">
      <div class="left-title list-border flex-between">
        <span>轮巡资源列表</span>
        <el-button type="text"
                   class="iconfont-lunan icon-lunan-return1"
                   title="返回"
                   @click="returnBack"></el-button>
      </div>
      <div class="pl10 list-border">
        <el-button type="text"
                   class="el-icon-plus"
                   title="新增轮巡"
                   @click="addVideoTour(1)"></el-button>
        <!-- <el-button type="text"
                           class="el-icon-delete-solid"
                           size="mini"
                           @click=""></el-button> -->
      </div>
      <div>
        <el-scrollbar ref="scrollBar"
                      class="scroll-bar">
          <el-tree ref="eventCategoryTree"
                   :data="loopData"
                   :props="defaultProps"
                   node-key="tourCode"
                   highlight-current
                   default-expand-all
                   :expand-on-click-node="false"
                   @node-click="showScene">
            <div class="custom-tree-node flex-row"
                 slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <div class="area-operator ml20">
                <!-- 新增场景 -->
                <el-button type="text"
                           class="el-icon-plus"
                           size="mini"
                           v-if="node.level===1"
                           title="新增场景"
                           @click.stop="() => addVideoScene(node,data)"></el-button>
                <!-- 删除轮巡 / 场景 -->
                <el-button type="text"
                           class="el-icon-delete-solid"
                           size="mini"
                           :title="node.level===1?'删除轮巡':'删除场景'"
                           @click.stop="() => remove(node, data)"></el-button>
                <!-- 修改轮巡 / 场景-->
                <el-button type="text"
                           class="el-icon-edit-outline"
                           size="mini"
                           :title="node.level===1?'修改轮巡名称':'修改场景'"
                           @click.stop="() => updataVideoTour(node, data)"></el-button>
              </div>
            </div>
          </el-tree>
        </el-scrollbar>
      </div>
    </div>
    <!-- 中部 新增、修改信息填写 -->
    <div class="content-middle">
      <div class="flex-row ml10 mt10">
        <span class="config-label">场景名称：</span>
        <el-input v-model="sceneName"
                  style="width:200px"
                  :disabled="disabled"
                  placeholder="请输入场景名称"></el-input>
      </div>
      <!-- <div class="flex-row ml10 mt10 config-item"> -->

      <div class="flex-row ml10 mt10">
        <span class="config-label">轮巡时间：</span>
        <el-input v-model="tourSceneTime"
                  :disabled="disabled"
                  style="width:200px"></el-input>
        <div class="config-label ml5">s</div>
      </div>
      <div class="ml10 mt10">
        <span class="config-label">轮巡窗口数：</span>
        <el-select v-model="tourSceneScreen"
                   style="width:200px"
                   :disabled="disabled">
          <el-option v-for="item in typeOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <span class="ml5">（注：摄像机数必须小于轮巡窗口数）</span>
      </div>
      <!-- </div> -->
      <div class="config-table">
        <ioc-table ref="crud"
                   :data="tableData"
                   :option="option">
          <!-- 表格按钮 自定义 -->
          <template slot="menu"
                    slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        content="删除"
                        placement="top"
                        popper-class="tooltip-draw">
              <el-button type="text"
                         icon="el-icon-delete"
                         :disabled="disabled"
                         @click="handleDel(scope.row, scope.index)"></el-button>
            </el-tooltip>
          </template>
        </ioc-table>
      </div>
      <div class="bottom">
        <el-button type="primary"
                   size="small"
                   :disabled="disabled"
                   @click="sceneConfirm">保存</el-button>
        <el-button :disabled="disabled"
                   @click="cancelConfig">取消</el-button>
        <span class="ml10">注：正在运行的轮巡不能及时生效，需要重新启动该轮巡</span>
      </div>
    </div>
    <div class="content-right flex-valign">
      <area-device-tree ref="deviceTree"
                        @cameraData="cameraData"
                        :multiCheck="true"></area-device-tree>
      <div class="text-center mb10">
        <el-button type="primary"
                   size="small"
                   :disabled="disabled"
                   @click="confirmCamera">确认</el-button>
      </div>

    </div>
    <el-dialog :title="isAdd===1?'新增轮巡':'修改轮巡'"
               :visible.sync="dialogVisible"
               v-dialogDrag
               width="30%">
      <div class="flex-row">
        <label class="tour-title">轮巡名称：</label>
        <el-input v-model="tourName"
                  placeholder="请输入名称"
                  style="width:200px"></el-input>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="addTourCancel">取 消</el-button>
        <el-button type="primary"
                   @click="addTourConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template> 
<script>
// 区域设备树
import areaDeviceTree from "@src/components/common/app-area-list";
import { api } from "../api.js";
import { Dates } from "@src/common/utils";
import tableOption from '../const/option'

export default {
  components: {
    areaDeviceTree,
  },
  data () {
    return {
      currentDevice: {},
      videoSearchActive: false,
      queryBackData: null,
      searchVideoStartTime: null,
      searchVideoEndTime: null,
      isVideos: false,
      playType: "video-live",
      tourSceneScreen: 4,
      typeOptions: [
        {
          label: '一分屏',
          value: 1
        },
        {
          label: '四分屏',
          value: 4
        },
        {
          label: '六分屏',
          value: 6
        }
        // {
        //   label: '九分屏',
        //   value: 9
        // }
      ],
      tourSceneTime: 30,
      option: tableOption(this),
      tableData: [],
      // loopData: [
      //   {
      //     "tourCode": "20201224000002",               // 轮巡编码
      //     "tourName": "测试修改",                     // 轮巡名称
      //     "creator": "gutao",
      //     "createTime": "2020-12-24 17:31:49",
      //     "modifier": "gutao",
      //     "modifyTime": "2020-12-24 18:33:48",
      //     "pageNum": null,
      //     "pageSize": null,
      //     "videoTourSceneInfoList": [
      //       {
      //         "tourCode": "20201224000011",        // 场景编码
      //         // "tourCode": null,
      //         "tourSceneTime": "90",                    // 时间
      //         "tourSceneScreen": "4",
      //         "tourName": "544俺师傅说",           // 场景名称
      //         "thirdDeviceIdList": null,
      //         "creator": "gutao",
      //         "createTime": "2020-12-24 18:49:20",
      //         "modifier": null,
      //         "modifyTime": null,
      //         "tourSceneCameraInfoList": [
      //           {
      //             "thirdDeviceId": "e9fe9a88-d205-4c06-80c9-402b50be7643",    // 第三方摄像机Id
      //             "deviceId": "20201224000019",                               // 摄像机id
      //             "deviceName": "摄像机A",                                    // 摄像机名称
      //           },
      //           {
      //             "thirdDeviceId": "e9fe9a88-d205-4c06-80c9-402b50be7659",
      //             "deviceId": "20201224000029",
      //             "deviceName": "摄像机B",
      //           }
      //         ]
      //       },
      //       {
      //         "tourCode": "20201224000002",
      //         // "tourCode": null,
      //         "tourSceneTime": "60",
      //         "tourSceneScreen": "4",
      //         "tourName": "测试场景",
      //         "thirdDeviceIdList": null,
      //         "creator": "gutao",
      //         "createTime": "2020-12-24 18:20:48",
      //         "modifier": "gutao",
      //         "modifyTime": "2020-12-24 18:37:41",
      //         "tourSceneCameraInfoList": [
      //           {
      //             "thirdDeviceId": "e9fe9a88-d205-4c06-80c9-402b50be7658",    // 第三方摄像机Id
      //             "deviceId": "20201224000519",                               // 摄像机id
      //             "deviceName": "摄像机C",                                    // 摄像机名称
      //           }
      //         ]
      //       }
      //     ]
      //   },
      //   {
      //     "tourCode": "20201224000011",
      //     "tourName": "测试轮巡",
      //     "creator": "gutao",
      //     "createTime": "2020-12-24 18:12:17",
      //     "modifier": null,
      //     "modifyTime": null,
      //     "pageNum": null,
      //     "pageSize": null,
      //     "videoTourSceneInfoList": []
      //   }
      // ],
      loopData: [],
      defaultProps: {
        children: 'videoTourSceneInfoList',
        label: 'tourName'
      },
      dialogVisible: false,
      tourName: '',
      tourCode: null,
      sceneName: '',
      isAdd: 1, // 1.新增 2. 修改
      isSceneAdd: 1,
      disabled: true,
      choosedCamera: [],
      thirdDeviceIdList: [],
      deviceIdList: []
    };
  },
  created () { },
  mounted () {
    this.queryTourList()
  },
  methods: {
    // 自定义渲染节点
    // renderContent (h, { node, data, store }) {
    //   return (
    //     <span class="custom-tree-node personwidth" title={node.label}>
    //       <span>{node.label}<i class="iconfont-lunan icon-lunan-jia-copy" style="margin-left: 5px;font-size:12px"></i></span>
    //     </span>);
    // },
    cameraData (data) {
      this.$log.info('cameraData', data);
      if (data.length > this.tourSceneScreen) {
        this.$message.warning(`摄像机数必须小于轮巡窗口数，当前已选数量${data.length},窗口数为${this.tourSceneScreen}`)
        // this.$refs.deviceTree.setAttributeNode
      }
      this.choosedCamera = data;
    },
    confirmCamera () {
      if (this.choosedCamera.length > this.tourSceneScreen) {
        this.$message.warning('摄像机数必须小于轮巡窗口数')
      } else {
        this.tableData = this.choosedCamera.map(item => {
          return {
            thirdDeviceId: item.thirdCameraId,    // 第三方摄像机Id
            deviceId: item.id,                    // 摄像机id
            deviceName: item.name,                // 摄像机名称
          }
        })
        console.log(' this.cameraData', this.tableData)
        this.thirdDeviceIdList = this.choosedCamera.map(item => {
          return item.thirdCameraId
        })
      }
    },
    // 打开新增轮巡 
    addVideoTour (node, data) {
      this.isAdd = 1
      this.dialogVisible = true
    },
    //提交新增
    addTourConfirm () {
      const url = this.isAdd === 1 ? api.addVideoTour : api.updateVideoTour
      let params = { tourName: this.tourName }
      if (this.isAdd === 2) {
        params.tourCode = this.tourCode
      }
      this.$fetch(url, params).then(res => {
        if (res.success) {
          this.$message.success(`${this.isAdd === 1 ? '新增' : '修改'}成功`)
          this.tourName = ''
          this.dialogVisible = false
          this.queryTourList()
        } else {
          this.$message.success(res.msgContent || `${this.isAdd === 1 ? '新增' : '修改'}失败`)
        }
      })
    },
    //取消新增轮巡
    addTourCancel () {
      this.dialogVisible = false
      this.tourName = ''
    },
    updataVideoTour (node, data) {
      if (node.level === 1) {
        // 修改轮巡
        this.isAdd = 2
        this.dialogVisible = true
        this.tourName = node.label
        this.tourCode = data.tourCode
      } else {
        //修改场景
        this.isSceneAdd = 2
        this.disabled = false
        this.sceneName = node.label
        this.tourCode = node.parent.data.tourCode
        this.tourSceneCode = data.tourSceneCode
        this.tourSceneScreen = data.tourSceneScreen
        this.tourSceneTime = data.tourSceneTime
        this.tableData = data.tourSceneCameraInfoList
        this.thirdDeviceIdList = data.tourSceneCameraInfoList.map(item => {
          return item.thirdDeviceId
        })
        this.deviceIdList = data.tourSceneCameraInfoList.map(item => {
          return item.deviceId
        })
        this.$refs.deviceTree.setChecked(this.deviceIdList)
      }
    },
    //新增场景
    addVideoScene (node, data) {
      this.disabled = false
      this.isSceneAdd = 1
      this.tourCode = data.tourCode
    },
    remove (node, data) {
      this.$confirm(
        `是否删除此${node.level === 1 ? "轮巡" : "场景"}`,
        "确认",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        if (node.level === 1) {
          this.$fetch(api.deleteVideoTour, { tourCode: data.tourCode }).then(res => {
            if (res.success) {
              this.$message.success('删除轮巡成功')
              this.queryTourList()
            } else {
              this.$message.success(res.msgContent || '删除轮巡失败')
            }
          })
        } else {
          this.$fetch(api.deleteVideoTourScene, { tourSceneCode: data.tourSceneCode }).then(res => {
            if (res.success) {
              this.$message.success('删除场景成功')
              this.queryTourList()
            } else {
              this.$message.success(res.msgContent || '删除场景失败')
            }
          })
        }
      })

    },

    queryTourList () {
      this.$fetch(api.queryVideoTour, {
        pageNum: 1,
        pageSize: 999
      }).then(res => {
        if (res.success) {
          this.loopData = res.returnObj.list
        } else {
          this.$message.success(res.msgContent)
        }
      })
    },
    showScene (data, node) {
      if (!this.disabled) {
        this.$confirm(
          `是否需要先保存当前轮巡场景`,
          "确认",
          {
            confirmButtonText: "保存",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.sceneConfirm()
        }).catch(() => {
          if (node.level === 1) {
            // 点击轮巡节点
            this.cancelConfig()
          } else {
            this.showSceneDetail(data)
          }
        })
      } else {
        if (node.level === 1) {
          // 点击轮巡节点
          this.cancelConfig()
        } else {
          this.showSceneDetail(data)
        }
      }
    },
    //新增/修改场景
    sceneConfirm () {
      const params = {
        thirdDeviceIdList: this.thirdDeviceIdList,
        tourCode: this.tourCode,
        tourSceneName: this.sceneName,
        tourSceneScreen: this.tourSceneScreen,
        tourSceneTime: this.tourSceneTime,
        tourSceneCode: this.tourSceneCode
      }
      const url = this.isSceneAdd === 1 ? api.addVideoTourScene : api.updateVideoTourScene
      this.$fetch(url, params).then(res => {
        if (res.success) {
          this.$message.success(`${this.isSceneAdd === 1 ? '新增' : '修改'}成功`)
          this.cancelConfig()
          this.queryTourList()
        } else {
          this.$message.success(res.msgContent || `${this.isSceneAdd === 1 ? '新增' : '修改'}失败`)
        }
      })
    },
    showSceneDetail (data) {
      this.disabled = true;
      this.tableData = data.tourSceneCameraInfoList;
      this.sceneName = data.tourName
      this.tourSceneScreen = data.tourSceneScreen
      this.tourSceneTime = data.tourSceneTime
      this.deviceIdList = data.tourSceneCameraInfoList.map(item => {
        return item.deviceId
      })
      this.$refs.deviceTree.setChecked(this.deviceIdList)
    },
    cancelConfig () {
      //  this.$confirm(
      //     `是否放弃当前操作`,
      //     "确认",
      //     {
      //       confirmButtonText: "保存",
      //       cancelButtonText: "取消",
      //       type: "warning",
      //     }
      //   ).then(() => {
      this.disabled = true;
      this.sceneName = '';
      this.tourSceneTime = 30;
      this.tourSceneScreen = 4;
      this.tableData = [];
      this.thirdDeviceIdList = [];
      this.$refs.deviceTree.setChecked([])
    },
    returnBack () {
      this.$router.go(-1)
    },
    handleDel (row, index) {
      this.$confirm(
        `是否删除当前摄像机`,
        "确认",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.tableData.splice(index, 1)
        this.deviceIdList.splice(index, 1)
        this.thirdDeviceIdList.splice(index, 1)
        this.$refs.deviceTree.setChecked(this.deviceIdList)
      })
    }
  },
};
</script>
<style lang="scss">
@import "../style/videoConfig.scss";
</style>

